import React from 'react';
import { breakpoints } from '@naf/theme';
import { GridCol } from '@naf/grid';
import { getCardMemberLabel } from '@lib/getCardMemberLabel';
import { RelatedArticleType } from '../../../../../types/articleType';
import { useResponsiveImageSize } from '../../../hooks/useResponsiveImageSize';
import { useDocumentUrlWithNode } from '../../../hooks/Documents/useDocumentUrl';
import { StyledLink } from '../../../components/styled-link/StyledLink';
import { StyledCardGrid } from '../Styles';
import { useCloudinary } from '../../../hooks/Cloudinary/useCloudinary';

export const ArticleCard = ({ article }: { article: RelatedArticleType }) => {
  const responsiveImagesSize = useResponsiveImageSize(536);
  const imagesSize: number =
    responsiveImagesSize?.width > parseInt(breakpoints.m, 10) ? 536 : responsiveImagesSize.width;

  const { getProcessedImage } = useCloudinary();

  const itemImage = getProcessedImage(article?.image?.publicId || article?.image?.public_id, {
    width: imagesSize,
  })?.toURL();

  const itemUrl = useDocumentUrlWithNode(article) || '';

  return (
    <GridCol s="12" m="12" l="6" xl="6" key={`article-item-${article.name}`}>
      <StyledLink to={itemUrl} $hasCardGrid>
        <StyledCardGrid
          titleAs="h2"
          title={article.name}
          description={article.ingress}
          media={{
            src: itemImage || '',
            alt: article.image?.altText || '',
          }}
          label={getCardMemberLabel(article.paywallDetails)}
        />
      </StyledLink>
    </GridCol>
  );
};
